import React from "react";
import { IconProps } from "./IconProps";

const XCloseIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9562 15.2938C16.0023 15.3367 16.0392 15.3884 16.0649 15.4459C16.0905 15.5034 16.1043 15.5655 16.1054 15.6284C16.1065 15.6914 16.0949 15.7539 16.0713 15.8123C16.0477 15.8706 16.0127 15.9237 15.9681 15.9682C15.9236 16.0127 15.8706 16.0478 15.8122 16.0714C15.7539 16.0949 15.6914 16.1065 15.6284 16.1054C15.5655 16.1043 15.5034 16.0905 15.4459 16.0649C15.3884 16.0393 15.3367 16.0023 15.2937 15.9563L10 10.6633L4.70625 15.9563C4.61739 16.0391 4.49986 16.0842 4.37842 16.082C4.25698 16.0799 4.14111 16.0307 4.05523 15.9448C3.96935 15.8589 3.92015 15.743 3.91801 15.6216C3.91587 15.5002 3.96095 15.3826 4.04375 15.2938L9.33671 10L4.04375 4.70628C3.96095 4.61742 3.91587 4.49989 3.91801 4.37845C3.92015 4.25701 3.96935 4.14115 4.05523 4.05526C4.14111 3.96938 4.25698 3.92018 4.37842 3.91804C4.49986 3.9159 4.61739 3.96098 4.70625 4.04378L10 9.33674L15.2937 4.04378C15.3826 3.96098 15.5001 3.9159 15.6216 3.91804C15.743 3.92018 15.8589 3.96938 15.9448 4.05526C16.0306 4.14115 16.0798 4.25701 16.082 4.37845C16.0841 4.49989 16.039 4.61742 15.9562 4.70628L10.6633 10L15.9562 15.2938Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.74 20.25H4.73C4.54 20.25 4.36 20.17 4.22 20.03C4.08 19.89 4 19.72 4 19.52C4 19.32 4.07 19.14 4.2 19L11.06 12.14L4.2 5.28C4.07 5.14 4 4.95 4 4.76C4 4.57 4.08 4.39 4.22 4.25C4.36 4.11 4.53 4.03 4.73 4.03C4.92 4.03 5.11 4.1 5.25 4.23L12.11 11.09L18.97 4.23C19.04 4.16 19.12 4.1 19.21 4.06C19.3 4.02 19.4 4 19.5 4C19.6 4 19.7 4.02 19.79 4.05C19.88 4.09 19.97 4.14 20.04 4.21C20.11 4.28 20.17 4.37 20.2 4.46C20.24 4.55 20.25 4.65 20.25 4.75C20.25 4.85 20.23 4.95 20.19 5.04C20.15 5.13 20.09 5.21 20.02 5.28L13.16 12.14L20.02 19C20.15 19.14 20.23 19.33 20.22 19.52C20.22 19.71 20.14 19.89 20 20.03C19.86 20.17 19.68 20.24 19.49 20.25C19.3 20.26 19.11 20.18 18.97 20.05L12.11 13.19L5.25 20.05C5.11 20.18 4.93 20.25 4.74 20.25Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.7071 24.2926C25.8 24.3855 25.8737 24.4958 25.924 24.6172C25.9743 24.7386 26.0001 24.8687 26.0001 25.0001C26.0001 25.1315 25.9743 25.2616 25.924 25.383C25.8737 25.5044 25.8 25.6147 25.7071 25.7076C25.6142 25.8005 25.5039 25.8742 25.3825 25.9245C25.2611 25.9747 25.131 26.0006 24.9996 26.0006C24.8682 26.0006 24.7381 25.9747 24.6167 25.9245C24.4953 25.8742 24.385 25.8005 24.2921 25.7076L15.9996 17.4138L7.70708 25.7076C7.51944 25.8952 7.26494 26.0006 6.99958 26.0006C6.73422 26.0006 6.47972 25.8952 6.29208 25.7076C6.10444 25.5199 5.99902 25.2654 5.99902 25.0001C5.99902 24.7347 6.10444 24.4802 6.29208 24.2926L14.5858 16.0001L6.29208 7.70757C6.10444 7.51993 5.99902 7.26543 5.99902 7.00007C5.99902 6.7347 6.10444 6.48021 6.29208 6.29257C6.47972 6.10493 6.73422 5.99951 6.99958 5.99951C7.26494 5.99951 7.51944 6.10493 7.70708 6.29257L15.9996 14.5863L24.2921 6.29257C24.4797 6.10493 24.7342 5.99951 24.9996 5.99951C25.2649 5.99951 25.5194 6.10493 25.7071 6.29257C25.8947 6.48021 26.0001 6.7347 26.0001 7.00007C26.0001 7.26543 25.8947 7.51993 25.7071 7.70757L17.4133 16.0001L25.7071 24.2926Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default XCloseIcon;
